import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index.es'

const Icon = ({ children, fa, name, size, cssClass, forceSize, shape, style, color = 'black', flip, faIconStyle }) => {
    const renderChildren = () => {
        // if we wan't to use fa-layers etc, we can just pass more complex stuff as children
        if (children) return children

        // skip font awesome icon render if we are not rendering fa icon
        return fa && name ? (
            <FontAwesomeIcon
                icon={name}
                color={color}
                flip={flip}
                style={faIconStyle}
            />
        ) : null
    }

    return (
        <i
            className={classNames(
                'icon',
                shape ? `icon--shape-${shape}` : '',
                { [`icon--${name}`]: !fa ? name : false },
                { [cssClass]: cssClass },
                { [`icon--${size}`]: size },
                { 'icon--force-size': forceSize }, // ignore responsive sizes
            )}
            style={style}
        >
            {renderChildren()}
        </i>
    )
}

Icon.propTypes = {
    fa: PropTypes.bool, // use font awesome
    children: PropTypes.node,
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    size: PropTypes.string,
    forceSize: PropTypes.bool,
    shape: PropTypes.string,
    style: PropTypes.object,
    color: PropTypes.string,
    flip: PropTypes.string,
    faIconStyle: PropTypes.object,
    cssClass: PropTypes.string,
}

export default React.memo(Icon)
